import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { API_URL } from '../../config/apiEndpoints';
import { getFavoriteMovies, getFavoriteMoviesSeeMore, removeMovieFromFavorite } from '../../../SHARED/actions/profile.actions';
import { Link } from 'react-router-dom';
import {slugify} from '../../helpers/general.helper';
import Parser from 'html-react-parser';


class SavedItem extends Component {

    componentWillMount(){
        this.props.getFavoriteMovies();
    }
    removeMovieFromFavorite = (movieId, pager) => {
        this.props.removeMovieFromFavorite({movieId, pager});
    }

    seeMore = () => {
        this.props.getFavoriteMoviesSeeMore(this.props.favoriteMovies.pager.current_page + 1);
    }

    getSeeMoreCondition = () => {      
        if(this.props.favoriteMovies.rows && this.props.favoriteMovies.rows.length > 0){
            return (
                <div className="col see-more nopadding">
                    <span onClick={this.seeMore}>{this.props.favoriteMovies.rows.length !== this.props.favoriteMovies.pager.total_items ? "Vezi mai multe..." : "" }</span>
                </div>
            );
        }
    }

    getTotalItems = () => {
        return this.props.favoriteMovies.pager ? this.props.favoriteMovies.pager.total_items : 0
    }

    getContent = () => {
        if(this.props.favoriteMovies.rows){
            return this.props.favoriteMovies.rows.map((card, i) => {
                return <div className="item-svd" key={i}>
                    <div className="row">
                        <div className="col-2 image-holder">
                            <Link to={`/film/${card.film_id}/${slugify(card.film_title)}`} >
                                <img alt="Film" src={API_URL + card.film_poster} />
                            </Link>
                        </div>
                        <div className="col-10 list-view">
                            <div className="movie-item-list-view">
                                <div className="col-12 title-holder">
                                    <Link to={`/film/${card.film_id}/${slugify(card.film_title)}`} className="white-text">
                                        <span className="title-item">{Parser(card.film_translated_title)}<span className="year-item">({card.film_release_year})</span></span>
                                    </Link>
                                </div>
                                <div className="col-12 romanian-translation-title grey-text"><span>{Parser(card.film_title)}</span></div>
                                <span className="genre">Gen: {card.film_genre}</span>
                                <div className="col-12 imdb">
                                    <span className="imdb-icon float-left" />
                                    <span className="grade fs12 float-left">{card.film_rating_imdb}</span>
                                    <span className="star-icon float-left" />
                                </div>
                                <div>
                                    <span className="saved-status fs12 grey-text">STATUS: <span className="white-text">{card.film_status}</span></span>
                                </div>
                                <div className="col-12 additional-details-list">
                                <span className="other-details dark-grey-text"> {card.film_age_restrictions} | {card.film_duration} | {card.film_genre}</span>
                                    <span className="other-details dark-grey-text">Director {card.film_director}</span>
                                    <span className="other-details dark-grey-text">{card.film_cast_short}</span>
                                </div>
                                <span className="notif-delete" onClick={() => this.removeMovieFromFavorite(card.favorite_uuid, this.props.favoriteMovies.pager)} />
                                {/*<span className="social-sharing"/>*/}
                            </div>
                        </div>
                    </div>
                </div>
            })
        }
    }

    render() {
        return (
            <Fragment>
                <div className="profile-item-header">
                    <span className="icon-saved float-left" />
                    <span className="profile-notif-summary">Salvate de tine ({this.getTotalItems()})</span>
                </div>
                <div className="saved-item">
                    {this.getContent()}
                </div>
                {this.getSeeMoreCondition()}
            </Fragment> 
        );
    }
}

const mapStateToProps = state => ({
    favoriteMovies: state.profile.favoriteMovies
});
export default connect(mapStateToProps, {getFavoriteMovies, getFavoriteMoviesSeeMore, removeMovieFromFavorite})(SavedItem);


// WEBPACK FOOTER //
// ./src/SHARED/components/saveditem/saveditem.component.js